import './Brands.css';
import brandImage from '../assets/5bet_image_2.png';

const Brands = () => {
  return (
    <div className="brands-section" id="section-brands">
      <h2 className="brands-section__title">OUR BRANDS</h2>
        <div className="brands-section__container">
            <div className="brands-section__content">
                <h3 className="brands-section__brand-title">5BET</h3>
                <p className="brands-section__description">
                    5bet is a newly launched online casino offering a modern platform and a wide game selection.
                    With fast payouts and a smooth user experience, the focus is on player accessibility and engagement.
                    Built to support consistent performance and long-term value.
                </p>
                <a href="https://5bet.com/en" target="_blank" rel="noopener noreferrer">
                  <button className="brands-section__button">Visit Brand</button>
                </a>
            </div>
            <div className="brands-section__image-wrapper">
                <img src={brandImage} alt="5bet" className="brands-section__image"/>
            </div>
        </div>
    </div>
  );
};

export default Brands;
